export const messages = {
  en: {
    editScheduleClasses: {
      title: 'Edit Schedule',
      name: 'Schedule Name',
      namePlaceholder: 'Required, please enter schedule name',
      scheduleType: 'Schedule Type',
      scheduleTypePlaceholder: 'Required, please select schedule type',
      daySchedule: 'Daily Schedule',
      weekSchedule: 'Weekly Schedule',
      monthSchedule: 'Monthly Schedule',
      rest: 'Rest'
    },
    scheduleClassesDay: {
      scheduleCycle: 'Schedule Cycle',
      scheduleCyclePlaceholder: 'Required, please select schedule cycle',
      day: 'Day',
      scheduleInfo: 'Schedule Information',
      rest: 'Rest'
    },
    scheduleClassesWeek: {
      scheduleCycle: 'Schedule Cycle',
      scheduleCyclePlaceholder: 'Required, please select schedule cycle',
      week: 'Week',
      scheduleInfo: 'Schedule Information',
      rest: 'Rest'
    },
    scheduleClassesMonth: {
      scheduleCycle: 'Schedule Cycle',
      scheduleCyclePlaceholder: 'Required, please select schedule cycle',
      month: 'Month',
      scheduleInfo: 'Schedule Information',
      rest: 'Rest'
    },
 
  },
  zh: {
    editScheduleClasses: {
      title: '修改排班',
      name: '排班名称',
      namePlaceholder: '必填，请填写计划名称',
      scheduleType: '排班类型',
      scheduleTypePlaceholder: '必填，请选择排班类型',
      daySchedule: '按日排班',
      weekSchedule: '按周排班',
      monthSchedule: '按月排班',
      rest: '休息'
    },
    scheduleClassesDay: {
      scheduleCycle: '排班周期',
      scheduleCyclePlaceholder: '必填，请选择排班周期',
      day: '日',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    scheduleClassesWeek: {
      scheduleCycle: '排班周期',
      scheduleCyclePlaceholder: '必填，请选择排班周期',
      week: '周',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
    scheduleClassesMonth: {
      scheduleCycle: '排班周期',
      scheduleCyclePlaceholder: '必填，请选择排班周期',
      month: '月',
      scheduleInfo: '排班信息',
      rest: '休息'
    },
  }
}